// "Número de convidados esperados" do Evento (item 2, 01/10).
//
// É o pax que TODA conta do orçamento usa (faixa do FEE por categoria da AbbVie,
// FEE real do fechamento exterior). Antes era o `quantidadeConvidados` da aba RSVP,
// que continua existindo para o RSVP — mas o orçamento não lê mais ele.
//
// Validação em 2 camadas: a mesma regra (vazio/≤0 = inválido) vale na tela do
// Evento (campo obrigatório), na tela do Orçamento (Salvar travado) e na API (422).

export const CAMPO_CONVIDADOS_ESPERADOS = 'quantidadeConvidadosEsperados';

export const MENSAGEM_CONVIDADOS_ESPERADOS_ORCAMENTO = 'Informe o Número de convidados esperados no cadastro do evento antes de salvar o orçamento.';

export const MENSAGEM_CONVIDADOS_ESPERADOS_EVENTO = 'Informe o Número de convidados esperados (maior que zero) antes de salvar o evento.';

// Número ou null. Aceita número, string "120" ou "120,0"; vazio/lixo vira null.
export function normalizarConvidadosEsperados(valor) {
    if (valor === null || valor === undefined) return null;
    if (typeof valor === 'number') return Number.isFinite(valor) ? valor : null;
    const texto = String(valor).trim();
    if (texto === '') return null;
    const numero = Number(texto.replace(',', '.'));
    return Number.isFinite(numero) ? numero : null;
}

export function temConvidadosEsperadosValido(valor) {
    const numero = normalizarConvidadosEsperados(valor);
    return numero !== null && numero > 0;
}

// Lê do objeto evento de forma defensiva (campo pode não vir de uma API antiga).
export function convidadosEsperadosDoEvento(evento) {
    if (!evento || typeof evento !== 'object') return null;
    return normalizarConvidadosEsperados(evento[CAMPO_CONVIDADOS_ESPERADOS]);
}

// Pax para as contas do orçamento: o valor válido ou 0.
export function paxConvidadosEsperados(valor) {
    return temConvidadosEsperadosValido(valor) ? normalizarConvidadosEsperados(valor) : 0;
}

// O Salvar do orçamento trava quando HÁ evento e ele não tem o número.
// Orçamento sem evento: a regra não se aplica.
export function orcamentoBloqueadoPorConvidadosEsperados({ eventoId, convidadosEsperados } = {}) {
    const temEvento = eventoId !== null && eventoId !== undefined && String(eventoId).trim() !== '';
    if (!temEvento) return false;
    return !temConvidadosEsperadosValido(convidadosEsperados);
}
